<!-- 领取成功页 -->
<template>
  <div class="success-box">
      <div  class="get-success">
         <div class="header">请务必添加您的专属顾问</div>
         <div class="header">获取更多礼包详情</div>

         <div class="counselor-img">
            <img alt="SharkPark" src="@/assets/7/01.png">
         </div>
        <div class="waring">长按图片即可添加</div>
      </div>
       
    </div>
</template>

<script>

// import { promotionPictureLink} from '@/api/agent'

export default {
  name: 'GraphValidateCode',
  data(){
    return {
     
    }
  },
  created() {
   
  },
  methods:{
    init(type){ //打开图形验证框
      this.show = true;
    },
    closeFun(){// 关闭
      this.show  = false;
    },
  }
}
</script>

<style lang="scss" scoped>
    .success-box {
        display: flex;
        align-items: center;
        height: 100vh;
        justify-content: center;
     .get-success {
         width: 100%;
        .header {
            font-size: 18px;
            font-weight: 600;
            width: 240px;
            margin: 0 auto;
            text-align: center;
        }
        .counselor-img {
            // display: block;
            text-align: center;
            margin: 10px 0;
        }
        .waring {
            text-align: center;
            font-size: 20px;
            font-weight: 600;
            color: #1a73e8;

        }
     }
    }
  
</style>
